import { cn } from "@/lib/utils";
import symbolUrl from "./flotion-symbol.png";

/**
 * Flotion identity — the client symbol mark + "FLOTION" wordmark.
 * The mark is the printed lockup (transparent PNG, fixed brand yellow), so it
 * does not recolor with theme. The wordmark inherits `currentColor`.
 */

interface MarkProps {
  /** Rendered width in px; height scales to preserve the artwork aspect ratio. */
  size?: number;
  className?: string;
}

export function FlotionMark({ size = 24, className }: MarkProps) {
  return (
    <img
      src={symbolUrl}
      alt=""
      aria-hidden="true"
      draggable={false}
      style={{ width: size, height: "auto" }}
      className={cn("block select-none", className)}
    />
  );
}

interface WordmarkProps {
  /** Font size in px. */
  height?: number;
  className?: string;
}

export function FlotionWordmark({ height = 20, className }: WordmarkProps) {
  return (
    <span
      style={{ fontSize: height }}
      className={cn("inline-block font-bold uppercase leading-none tracking-[0.04em]", className)}
    >
      Flotion
    </span>
  );
}

interface LogoProps {
  /** Mark width in px. */
  markSize?: number;
  /** Wordmark font size in px; defaults to ~0.8× the mark size. */
  wordmarkHeight?: number;
  /** Hide the wordmark to render the mark alone (e.g. collapsed rail, favicon). */
  showWordmark?: boolean;
  className?: string;
}

export function FlotionLogo({
  markSize = 24,
  wordmarkHeight,
  showWordmark = true,
  className,
}: LogoProps) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <FlotionMark size={markSize} />
      {showWordmark && <FlotionWordmark height={wordmarkHeight ?? Math.round(markSize * 0.8)} />}
    </span>
  );
}
